// gkc_hash_code : 01GPFQ2BY4JCG0W281FKCRX39R

import styles from './index.module.scss';
import { mergeClasses } from 'util/commons';
import { useEffect, useState } from 'react';
import { CollectRouteSiteInfo } from 'types/routeManagementTypes';
import { useSelector } from 'react-redux';
import { selectCollectingRouteSites } from 'redux/slices/collectingRoute';
import { SiteMemo } from 'components/molecules/SiteMemo';

const CollectRouteQRScanHeader = ({ siteId }: { siteId: string }) => {
  const collectingRouteSites = useSelector(selectCollectingRouteSites);
  const [currentSite, setCurrentSite] = useState<CollectRouteSiteInfo | null>(
    null
  );

  useEffect(() => {
    if (collectingRouteSites && collectingRouteSites.sites) {
      const foundSite = collectingRouteSites.sites.find(
        (site) => site.id === siteId
      );

      setCurrentSite(foundSite || null);
    }
  }, [collectingRouteSites, siteId]);

  if (!currentSite) {
    return null;
  }

  return (
    <div className={styles.headerContainer}>
      <div className={mergeClasses(styles.headerGroup, styles.headerCenter)}>
        <span className={styles.siteName}>{currentSite.name}</span>
        <SiteMemo siteId={siteId} />
      </div>
    </div>
  );
};

export default CollectRouteQRScanHeader;
